import React from 'react';
import { Box, Typography } from '@mui/material';
import ProviderDiscountList from './ProviderDiscountList';

const ProviderDiscountListPanel = (props) => {
  const { children, value, index } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
    >
      <Box display="flex" flexDirection="column" gap={1} mt={2}>
        <Typography color="primary" variant="h5">
          <b>Minhas promoções</b>
        </Typography>
        <ProviderDiscountList />
      </Box>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
};

export default ProviderDiscountListPanel;
